module.exports = __webpack_public_path__ + "images/application/radar-sweep@2x-5eebe2ed.png";